// Helper function to calculate duration between two time strings
  export const calculateDuration = (startTime: string, endTime: string): string => {
    if (!startTime || !endTime) return "";
    
    try {
      // Handling European date format (DD.MM.YYYY HH:MM:SS)
      const parseDate = (dateStr: string) => {
        const parts = dateStr.split(' ');
        if (parts.length !== 2) return new Date(dateStr); // fallback
        
        const dateParts = parts[0].split('.');
        const timeParts = parts[1].split(':');
        
        if (dateParts.length !== 3 || timeParts.length < 2) return new Date(dateStr); // fallback
        
        // Month is 0-indexed in JavaScript Date
        return new Date(
          parseInt(dateParts[2]), // year
          parseInt(dateParts[1]) - 1, // month (0-based)
          parseInt(dateParts[0]), // day
          parseInt(timeParts[0]), // hour
          parseInt(timeParts[1]), // minute
          timeParts.length > 2 ? parseInt(timeParts[2]) : 0 // seconds
        );
      };
      
      const start = parseDate(startTime);
      const end = parseDate(endTime);
      
      if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        console.error("Invalid date format", { startTime, endTime, start, end });
        return "";
      }
      
      // Calculate difference in milliseconds
      const diffMs = end.getTime() - start.getTime();
      
      // Convert to hours and minutes
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      
      // Format as hh:mm
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    } catch (error) {
      console.error("Error calculating duration:", error);
      return "";
    }
  };